// This React component, `GolfInsurancePage`, is a Next.js client component responsible for rendering the
//  Golf Insurance landing page. It retrieves data from the `dataSource` within the `data` prop and
//  passes it to the `GolfInsurance` component for display. By using `TasticProps<GolfInsurancePageProps>`,
//  it ensures type safety and structured data handling. This setup enables dynamic content rendering for
//  the Golf Insurance page efficiently.

'use client';

import React from 'react';
import { TasticProps } from '../types';
import GolfInsurance from 'components/commercetools-ui/organisms/landing-pages/golf-insurance';
import { GolfInsurancePageProps } from 'types/next';

const GolfInsurancePage = ({ data }: TasticProps<GolfInsurancePageProps>) => {
  const contentData = data?.data?.dataSource;

  return (
    <>
      <GolfInsurance golfInsurance={contentData} />
    </>
  );
};

export default GolfInsurancePage;
